/* 
  Note: this feature needs to be removed or updated
  after getting the existing subscription list
*/

// to be removed or moved to envars
const SERVER_URL = window.location?.origin &&
  window.location.origin.includes('www.opencampus.xyz') ?
  'https://web3.tinytap.com' : 'https://web3.tinytap.it';

export const subscribeUserEmail = async (email) => {
  // validate email format
  const emailInputValidator = new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)
  if (!emailInputValidator.test(email)) return false;

  // register
  try {
    const response = await fetch(`${SERVER_URL}/user_svc/signup/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email }),
    })

    return response.status === 200
  } catch (_) {
    return false
  }
}